import React, { useEffect, useState, useRef } from 'react'
import { debounce } from 'throttle-debounce'
import { trackPromise } from 'react-promise-tracker'

import WhatsNewList from './components/WhatsNewList'
import { GetWhatsNew, GetWhatsNewCategories } from '../../../../store/ContentfulClient'
import { SidebarSearch, SidebarFilter } from '../../../../components/SearchAndFilter'
import { Sidebar, MainContent } from '../../../../layouts/components/Structure'
import LoadingWrapper from 'components/LoadingWrapper'

const WhatsNewIndex = () => {
    const WhatsNewPromiseArea = 'whats-new-index'
    const WhatsNewSidebarPromiseArea = 'whats-new-categories'
    const [whatsNewItems, setWhatsNewItems] = useState([])
    const [whatsNewCateogories, setWhatsNewCategories] = useState([])

    const [typingSearchString, setTypingSearchString] = useState('')
    const [searchString, setSearchString] = useState('')
    const [selectedCategory, setSelectedCategory] = useState('')

    const realSearch = useRef(
        debounce(250, value => {
            setSearchString(value)
        })
    ).current

    useEffect(() => {
        trackPromise(
            GetWhatsNew(searchString, selectedCategory).then(items => {
                setWhatsNewItems(items)
            }),
            WhatsNewPromiseArea
        )
    }, [searchString, selectedCategory])

    useEffect(() => {
        const GetCategories = () => {
            trackPromise(
                GetWhatsNewCategories().then(items => {
                    setWhatsNewCategories(items)
                }),
                WhatsNewSidebarPromiseArea
            )
        }

        if (!whatsNewCateogories || whatsNewCateogories.length === 0) {
            GetCategories()
        }
    }, [whatsNewCateogories])

    const inputChanged = value => {
        setTypingSearchString(value)
        realSearch(value)
    }

    return (
        <>
            <Sidebar>
                <h2>What&apos;s New?</h2>
                <SidebarSearch
                    searchPlaceholder="Search Posts"
                    searchChange={inputChanged}
                    searchString={typingSearchString}
                />
                <SidebarFilter
                    selectedFilter={selectedCategory}
                    selectedFilterChange={setSelectedCategory}
                    promiseArea={WhatsNewSidebarPromiseArea}
                    filters={whatsNewCateogories}
                />
            </Sidebar>
            <MainContent>
                <LoadingWrapper area={WhatsNewPromiseArea}>
                    {whatsNewItems && whatsNewItems.length > 0 ? (
                        <WhatsNewList whatsNewItems={whatsNewItems} />
                    ) : (
                        <p>There are no documents matching your search</p>
                    )}
                </LoadingWrapper>
            </MainContent>
        </>
    )
}

export default WhatsNewIndex
